import React, { useEffect, useState, useRef } from 'react';
import styles from './Exhibition.module.css';

// Replace these imports with your actual image imports
import img1 from '../../../../assets/images/Exposição permanente.jpg';
import img2 from '../../../../assets/images/Exposição.jpg';
import img3 from '../../../../assets/images/Exposição1.jpg';
import img4 from '../../../../assets/images/Exposição2.jpg';
import img5 from '../../../../assets/images/Exposição3.jpg';
import { useNavigate } from 'react-router-dom';

const images = [
    { src: img1, position: "bottom" },
    { src: img2, position: "center" },
    { src: img3, position: "bottom" },
    { src: img4, position: "center" },
    { src: img5, position: "bottom" },
];

const Exhibition: React.FC = () => {
    const [status, setStatus] = useState(false);
    const [current, setCurrent] = useState(0);
    const [containerWidth, setContainerWidth] = useState(0);
    const navigate = useNavigate();

    const containerRef = useRef<HTMLDivElement>(null);

    // Update open/close status
    useEffect(() => {
        const checkOpenStatus = () => {
            const now = new Date();
            const options = { timeZone: 'Europe/Lisbon' };
            const localTime = new Date(now.toLocaleString('en-US', options));
            const day = localTime.getDay();
            const hours = localTime.getHours();
            const minutes = localTime.getMinutes();
            const currentTime = hours + minutes / 60;

            let isOpen = false;
            if (day >= 1 && day <= 5) {
                if (
                    (currentTime >= 8.5 && currentTime < 12.5) ||
                    (currentTime >= 14 && currentTime < 19)
                ) {
                    isOpen = true;
                }
            } else if (day === 6) {
                if (currentTime >= 8.5 && currentTime < 12.5) {
                    isOpen = true;
                }
            }
            setStatus(isOpen);
        };

        checkOpenStatus();
        const interval = setInterval(checkOpenStatus, 60000);
        return () => clearInterval(interval);
    }, []);

    // Measure container width and listen to resize
    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.offsetWidth);
            }
        };

        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    // Auto advance carousel every 5 seconds
    useEffect(() => {
        const id = setInterval(() => {
            setCurrent(c => (c + 1) % images.length);
        }, 2000);
        return () => clearInterval(id);
    }, [current]);

    // Calculate translateX based on current index and container width
    const translateX = -current * containerWidth;

    const handleSelect = (index: number) => setCurrent(index);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <div className={styles.items}>
                    <div className={styles.item}>
                        <div className={styles.header} ref={containerRef}>
                            {/* Images container with scroll effect */}
                            <div
                                className={styles.imagesContainer}
                                style={{
                                    width: `${images.length * containerWidth}px`,
                                    transform: `translateX(${translateX}px)`,
                                }}
                            >
                                {images.map((img, idx) => (
                                    <img
                                        key={idx}
                                        src={img.src}
                                        alt={`Slide ${idx + 1}`}
                                        className={styles.imageSlide}
                                        style={{
                                            width: `${containerWidth}px`,
                                            objectPosition: img.position,
                                        }}
                                        aria-hidden={idx !== current}
                                    />
                                ))}
                            </div>

                            {/* Status on top */}
                            <div className={styles.status}>
                                <div
                                    className={styles.circle}
                                    style={{ backgroundColor: status ? 'green' : 'red' }}
                                />
                                <span>{status ? 'Aberto' : 'Fechado'}</span>
                            </div>

                            {/* Image selector dots */}
                            <div className={styles.imageSelectorWrapper}>
                                <div className={styles.imageSelector}>
                                    {images.map((_, idx) => (
                                        <button
                                            key={idx}
                                            className={`${styles.dot} ${idx === current ? styles.active : ''}`}
                                            onClick={() => handleSelect(idx)}
                                            aria-label={`Selecionar imagem ${idx + 1}`}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className={styles.content}>
                            <div className={styles.title}>Exposição</div>
                            <div className={styles.description}>
                                <div className={styles.desc_item}>
                                    <span>
                                        Zona Industrial de Pinhal Basto
                                    </span>
                                    <span>4615-669</span>
                                    <span>Lixa, Portugal</span>
                                </div>
                                <div className={styles.desc_item_separator}>
                                    <div>
                                        <span>Segunda a Sexta-feira: </span>
                                        <span>08:30-12:30h | 14:00-19:00h</span>
                                    </div>
                                    <div>
                                        <span>Sábados:</span>
                                        <span>08:30-12:30h</span>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.footer}>
                                <span className={styles.button} onClick={() => window.open("https://www.google.com/maps/dir//N101-4+Macieira+da+Lixa/@41.3409782,-8.1571179,15z/data=!4m5!4m4!1m0!1m2!1m1!1s0xd24eaed69a10faf:0x2d9238335cc9bcd5", "_blank")}>Visite-nos</span>
                                <span className={styles.link} onClick={() => window.open("https://www.google.com/maps/dir//N101-4+Macieira+da+Lixa/@41.3409782,-8.1571179,15z/data=!4m5!4m4!1m0!1m2!1m1!1s0xd24eaed69a10faf:0x2d9238335cc9bcd5", "_blank")}>Obter direções</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.item} onClick={() => navigate("/servicos")}>
                        <div className={styles.services}>
                            <div className={styles.servicesSpacer}>
                                <div className={styles.title2}>Serviços</div>
                                <span className={styles.button2}>Saber Mais</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Exhibition;
